import { Link } from "Components"
import Config from "Data"
import React from "react"
import { IconContext } from "react-icons"
import { FaEnvelope, FaPhoneSquare } from "react-icons/fa"
import styled from "styled-components"
import { FooterSection, FullWrapper, media, mixins, Text } from "Styles"
import { theme } from "Theme"
import logo from "../../static/logo/CXOsync-h.png"
import { IconInstagram, IconLinkedin, IconTwitter } from "./icons"

const MODAL_ATTEND = "modal_attend"
const MODAL_SPONSOR = "modal_sponsor"

const Wrapper = styled.div`
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const StyledFullWrapper = styled(FullWrapper)`
  margin: 0;
  padding: 0 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
    margin: 0 auto;
  }
  @media (min-width: ${theme.breakpoints.m}) {
    padding: 0 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const UpperContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(22%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  }
  grid-gap: 1rem;
`

const Content = styled.section`
  line-height: initial;
  width: 100%;
  max-width: ${theme.layout.base};
  margin: 0 auto;
  ${mixins.flexBetween};
  flex-direction: column;
  border-top: 1px solid ${theme.colors.black.grey};
  margin-top: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const SocialContainer = styled.div`
  ${media.desktop`order: 1;`};
`

const SocialItemList = styled.ul`
  ${mixins.flexBetween};
  margin: 0;
  li {
    margin: 0;
  }
`

const FooterUpperBlock = styled.div`
  margin: 0;
  padding: 1rem 0;
  display: flex;
  align-self: flex-start;
  text-align: left;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    &.footer-last {
      align-items: flex-end;
      flex-direction: column;
    }
    padding: 2rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const FooterBottomBlock = styled.div`
  margin: 0;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    padding: 1rem 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const FooterColumn = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // width: 100%;
  a {
    display: block;
    padding: 6px 0;
  }
  svg {
    width: 18px;
    height: 18px;
  }
`

const FooterHeading = styled.h3`
  padding: 0 0 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1rem;
  color: inherit;
  font-weight: bold;
  min-height: 48px;
  @media (min-width: ${theme.breakpoints.m}) {
    min-height: 92px;
  }
  border-bottom: 1px solid ${theme.colors.black.grey};
`

const SocialLink = styled.a`
  margin: 0;
  padding: 1rem;
  svg {
    width: 18px;
    height: 18px;
  }
`

const StyledLink = styled((props) => <Link {...props} />)`
  position: relative;
  color: ${theme.colors.white.base};
  font-size: ${theme.fontSize.smallish};
  // text-decoration: underline;
  // font-weight: bold;
`

const StyledText = styled.span`
  position: relative;
  color: ${theme.colors.white.base};
  font-size: ${theme.fontSize.smallish};
  padding: 6px 0;
  // text-decoration: underline;
  // font-weight: bold;
`

const Footer = () => {
  return (
    <FooterSection id="footer">
      <Wrapper>
        <StyledFullWrapper>
          {/* <UpperContent>
                  <FormSubscribe
                    dark={true}
                    layout="rtl"
                    subtitle="Get updates and news about upcoming events delivered to your inbox!"
                    page={`pageName`}
                    audience={`audience`}
                    type={`secureCISO`}
                    notifyTemplate={`cxo-pages-new-lead`}
                  />
                </UpperContent> */}
          <UpperContent>
            <FooterUpperBlock>
              <FooterColumn>
                <FooterHeading>
                  <StyledLink to="/" alt={`${Config.brand} Logo`} track={"Footer Links"} title={`${Config.brand} Logo`}>
                    <img
                      src={logo}
                      alt=""
                      style={{
                        margin: "0",
                        padding: "4px 0",
                        width: "auto",
                        height: "32px",
                        filter: "grayscale(1) invert(1)",
                      }}
                    />
                  </StyledLink>
                </FooterHeading>
                <StyledLink to={`mailto:${Config.contact.email}`}>
                  <IconContext.Provider value={{ className: "react-icons color-grey" }}>
                    <FaEnvelope />
                  </IconContext.Provider>
                  {Config.contact.email}
                </StyledLink>
                <StyledLink to={`tel:${Config.contact.phone.us}`}>
                  <IconContext.Provider value={{ className: "react-icons color-grey" }}>
                    <FaPhoneSquare />
                  </IconContext.Provider>
                  US: {Config.contact.phone.us}
                </StyledLink>
                <StyledLink to={`tel:${Config.contact.phone.uk}`}>
                  <IconContext.Provider value={{ className: "react-icons color-grey" }}>
                    <FaPhoneSquare />
                  </IconContext.Provider>
                  UK: {Config.contact.phone.uk}
                </StyledLink>
                <StyledText to={`#`}>{Config.contact.address.street}</StyledText>
                <StyledText to={`#`}>
                  {Config.contact.address.city} {Config.contact.address.state}, {Config.contact.address.country}
                </StyledText>
              </FooterColumn>
            </FooterUpperBlock>
            <FooterUpperBlock>
              <FooterColumn>
                <FooterHeading>Get Engaged</FooterHeading>
                <StyledLink onClick={this.toggleModal(MODAL_ATTEND, "item")}>Attending</StyledLink>
                <StyledLink onClick={this.toggleModal(MODAL_SPONSOR, "item")}>Sponsoring</StyledLink>
                <StyledLink to={"/"}>Speaking</StyledLink>
                <StyledLink to={"/"}>Host a CMOdinner</StyledLink>
              </FooterColumn>
            </FooterUpperBlock>
            {/* <FooterUpperBlock>
                    <FooterColumn>
                      <FooterHeading>CXOsync Brands</FooterHeading>
                      {Config.brands &&
                        Config.brands.map(
                          ({ name, displayName, url }, i) =>
                            url !== "" && (
                              <StyledLink key={i} to={url} target="_blank" rel="nofollow noopener noreferrer">
                                {displayName}
                              </StyledLink>
                            )
                        )}
                    </FooterColumn>
                  </FooterUpperBlock> */}
            <FooterUpperBlock>
              <FooterColumn>
                <FooterHeading>Company</FooterHeading>
                <StyledLink to={"https://www.cxosync.com"}>About CXOsync</StyledLink>
                <StyledLink to={"#"}>FAQ</StyledLink>
                <StyledLink to={"/privacy/"}>Privacy Policy</StyledLink>
                <StyledLink to={"/terms/"}>Terms of use</StyledLink>
              </FooterColumn>
            </FooterUpperBlock>
            {/* <FooterUpperBlock className={"footer-last"}>
                    <FooterColumn>
                      <FooterHeading>
                        <StyledLink
                          to="/"
                          alt={`${Config.brand} Logo`}
                          track={"Footer Links"}
                          title={`${Config.brand} Logo`}>
                          <img
                            src={cxosync_logo}
                            alt=""
                            style={{ margin: "0", padding: "4px 0", width: "auto", height: "28px" }}
                          />
                        </StyledLink>
                      </FooterHeading>
                      {Config.brands &&
                        Config.brands.map(
                          ({ name, displayName, url }, i) =>
                            url !== "" && (
                              <StyledLink key={i} to={url} target="_blank" rel="nofollow noopener noreferrer">
                                {displayName}
                              </StyledLink>
                            )
                        )}
                    </FooterColumn>
                  </FooterUpperBlock> */}
            {/* <FooterUpperBlock>
                    <FooterColumn>
                      <FooterHeading>Join our mailing list!</FooterHeading>
                      <FormSubscribe
                        dark={true}
                        layout="rtl"
                        subtitle="Get updates and news about upcoming events delivered to your inbox!"
                        page={`pageName`}
                        audience={`audience`}
                        type={`secureCISO`}
                        notifyTemplate={`cxo-pages-new-lead`}
                      />
                    </FooterColumn>
                  </FooterUpperBlock> */}
          </UpperContent>
          <Content>
            <FooterBottomBlock>
              <Text>
                © {new Date().getFullYear()} {Config.contact.legalName}. All rights reserved.
              </Text>
            </FooterBottomBlock>
            <FooterBottomBlock>
              <SocialContainer>
                <SocialItemList>
                  {Config.socialMedia &&
                    Config.socialMedia.map(
                      ({ name, url }, i) =>
                        url !== "" && (
                          <li key={i}>
                            <SocialLink href={url} target="_blank" rel="nofollow noopener noreferrer" aria-label={name}>
                              {name === "Linkedin" ? (
                                <IconLinkedin />
                              ) : name === "Instagram" ? (
                                <IconInstagram />
                              ) : name === "Twitter" ? (
                                <IconTwitter />
                              ) : (
                                ""
                              )}
                            </SocialLink>
                          </li>
                        )
                    )}
                </SocialItemList>
              </SocialContainer>
            </FooterBottomBlock>
          </Content>
        </StyledFullWrapper>
      </Wrapper>
    </FooterSection>
  )
}

export default Footer
